var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cf-footer",attrs:{"id":"kt_copyright_footer"}},[_c('span',{staticClass:"cf-footer__text"},[_vm._v(" Copyright © "+_vm._s(_vm.currentYear)+" Total Biometric Solutions LLC. All rights reserved. ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }